import { PropTypes } from "mobx-react";

const extractNestedValue = (obj, target) => {
  const params = target.split(".");
  let value = obj;
  
  for (let i = 0; i < params.length; i++ ) {
    if (params[i+1] === "length") {
      return value[params[i]].length;
    } else {
      value = value[params[i]][0] || value[params[i]];
    }
  };

  return (!isNaN(value) || typeof value === "number") ? Number(value) : value.toLowerCase() ;
}

const sort = (array, sortBy) => {

  if (!isNaN(array[0][sortBy]) || typeof array[0][sortBy] === "number") {

    return array.sort((a, b) => {
      if (Number(a[sortBy]) < Number(b[sortBy])) {
        return -1;
      }
      if (Number(a[sortBy]) > Number(b[sortBy])) {
        return 1;
      }
      return 0;
    });
  };

  if (sortBy.includes(".")) {
    return array.sort((a,b)=> {
      if (extractNestedValue(a,sortBy) < extractNestedValue(b,sortBy)) {
        return -1;
      }
      if (extractNestedValue(a,sortBy) > extractNestedValue(b,sortBy)) {
        return 1;
      }
      return 0;
    })
  }

  if (!array[0][sortBy] || typeof array[0][sortBy] === "string") {
    console.log("start sort");
    return array.sort((a, b) => {
      if (!a[sortBy]) {
        return 1;
      }

      if (!b[sortBy]) {
        return -1;
      }

      if (!a[sortBy] || a[sortBy].toLowerCase() < b[sortBy].toLowerCase()) {
        return -1;
      }

      if (!a[sortBy] || a[sortBy].toLowerCase() > b[sortBy].toLowerCase()) {
        return 1;
      }
      return 0;
    });
  };
};

export default sort;